module.exports = __webpack_public_path__ + "static/media/0038.84820153.svg";